<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
import resize from "../mixins/resize";
import '../../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据

export default {
  name: "pingceCiyun",
    mixins: [resize],

    props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Object
    },
    center: {
      type: Array
    }
  },
  data() {
    return {
      chart: null,
      map: null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById(this.id));
      var mydata = [
        { name: "河北", value: 4 },
        { name: "山东", value: 3 },
        { name: "河南", value: 4 },
        { name: "重庆", value: 4 },
        { name: "广西", value: 4 },
        { name: "四川", value: 4 },
        { name: "海南", value: 4 },
        { name: "北京", value: 4 },
        { name: "天津", value: 4 },
        { name: "上海", value: 4 },
        { name: "江苏", value: 3 },
        { name: "浙江", value: 3 },
        { name: "福建", value: 3 },
        { name: "安徽", value: 4 },
        { name: "江西", value: 3 },
        { name: "湖北", value: 4 },
        { name: "湖南", value: 4 },
        { name: "广东", value: 4 },
        { name: "辽宁", value: 4 },
        { name: "吉林", value: 3 },
        { name: "黑龙江", value: 3 },
        { name: "内蒙古", value: 3 },
        { name: "云南", value: 4 },
        { name: "贵州", value: 4 },
        { name: "山西", value: 4 },
        { name: "陕西", value: 4 },
        { name: "甘肃", value: 4 },
        { name: "新疆", value: 4 },
        { name: "西藏", value: 3 },
        { name: "青海", value: 4 },
        { name: "宁夏", value: 4 },
        { name: "台湾", value: 4 },
        { name: "香港", value: 3 },
        { name: "澳门", value: 3 },
        {
          name: "南海诸岛",
          value: 0,
          itemStyle: { normal: { opacity: 0, label: { show: false } } }
        }
      ];

      let option = {
        // backgroundColor: "#f2f2f2",
        title: {
          text: "",
          subtext: "",
          x: "center",
          y: "5%"
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}"
        },
        roam: true,
        dataRange: {
          show: false,
          min: 0,
          max: 5,
          x: "10%",
          y: "88%",

          splitList: [
            {
                 start: this.chartData.start,
                    end: this.chartData.end,
                    label: 'IP分布',
                    color: this.chartData.color
             /* start: 3.5,
              end: 5,
              // label: "发展区",
              color: "#f2ea5f" //todo 填充颜色。*/
            }
          ],
          color: ["red", "blue"]
        },
        roamController: {
          show: true,
          x: "right",
          mapTypeControl: {
            china: true
          }
        },
        series: [
          {
            // name: "投标",
            type: "map",
            mapType: "china",
            roam: false,
            itemStyle: {
              normal: {
                borderWidth: 0.5, //区域边框宽度
                borderColor: "#009fe8", //区域边框颜色
                areaColor: "#ffefd5", //区域颜色
                label: {
                  show: true
                }
              }
            },
            data: mydata
          }
        ]
      };

      this.chart.setOption(option);
      this.chart.resize();

    }
  },
  watch: {
    //   center: function() {
    //     //this.chart.dispose();
    //     //this.chart = null;
    //      this.initChart();
    //   }
  }
};
</script>
<style scoped lang="less"></style>
